import * as points from './points';
import * as pipes from './pipes';

const survey = {
  points,
  pipes,
};
export default survey;
